export default {
  list: {
    name: "member list api",
    version: 6,
    url: "member@member",
    method: "GET",
  },
  add: {
    name: "add member api",
    version: 6,
    url: "member@member",
    method: "POST",
  },
  update: {
    name: "update member api",
    version: 6,
    url: "member@member/%{id}",
    method: "PUT",
  },
  delete: {
    name: "delete member api",
    version: 6,
    url: "member@member/%{id}",
    method: "DELETE",
  },
  deleteMemberCard: {
    name: "delete member card api",
    version: 6,
    url: "member@member-card/%{id}",
    method: "DELETE",
  },
  giftActivityList: {
    name: "member gift activity list api",
    version: 6,
    url: "member@member-gift-activity",
    method: "GET",
  },
  giftActivityCreate: {
    name: "member gift activity create api",
    version: 6,
    url: "member@member-gift-activity",
    method: "POST",
  },
  giftActivityUpdate: {
    name: "member gift activity update api",
    version: 6,
    url: "member@member-gift-activity/%{id}",
    method: "PUT",
  },
  giftActivityDelete: {
    name: "member gift activity delete api",
    version: 6,
    url: "member@member-gift-activity/%{id}",
    method: "DELETE",
  },
  giftActivityGenerateCodes: {
    name: "member gift activity generate codes api",
    version: 6,
    url: "member@member-gift-activity/%{id}/generate-codes",
    method: "POST",
  },
  giftActivityGenerateExcel: {
    name: "member gift activity generate excel api",
    version: 6,
    url: "member@member-gift-activity/%{id}/generate-excel",
    method: "POST",
  },
};
